<div
    data-testid="global-table-row-item"
    class="grid gap-2 bg-[var(--table-row-bg,var(--base-2))] hover:bg-[var(--table-row-bg-hover,var(--base-4))] cursor-pointer my-2 py-3 pr-4 pl-8 items-center rounded-md relative h-11 group"
    [style.grid-template-columns]="gridTemplateColumns()"
>
    <div class="absolute inset-x-0 top-2 bottom-2 pointer-events-none z-[11]">
        <span class="sticky left-4 block ml-4 h-full w-1 rounded-full" [style.background-color]="pillColor()"></span>
    </div>
    <ng-content selector="app-table-cell"></ng-content>
</div>
